import { Component, OnInit } from '@angular/core';
import { MmMenuApiService } from '../../services/menu-api.service';
import { NzTreeNode } from 'ng-zorro-antd/tree'
import { MenuItem } from '../../definition';
import { BehaviorSubject } from 'rxjs';
import { switchMap, map, tap, filter } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MenuFormComponent } from '../menu-form/menu-form.component';
import { TranslateService } from '@ngx-translate/core';
import { mmMenuConstants } from 'mm-web-core/menu/menu-constants';
import * as download from 'downloadjs'
import { NzIconService } from "ng-zorro-antd/icon";
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';


@Component({
  selector: 'mm-menu-management',
  templateUrl: './menu-management.component.html',
  styleUrls: ['./menu-management.component.scss']
})
export class MmMenuManagementComponent implements OnInit {
  nodes: NzTreeNode[]
  expandItems: ExpandMenuItem[];

  menus$ = new BehaviorSubject<MenuItem[]>([]);
  expandSet$ = new BehaviorSubject<any>({});


  expandItems$ = this.menus$.pipe(

    switchMap(menus => this.expandSet$.pipe(map(set => convertToExpandItems(menus, set)))),
    tap(items => {
    }),
  )

  constructor(private api: MmMenuApiService, private modalService: NzModalService, private translateService: TranslateService,
    private iconService: NzIconService) {
  }

  async ngOnInit() {
    const menus = await this.api.getMenuTree().toPromise();
    this.menus$.next(menus);
  }

  onExpandChange(id: string, expand: boolean) {
    const set = this.expandSet$.value;
    if (expand) {
      set[id] = true;
    }
    else {
      set[id] = false;
    }
    this.expandSet$.next(set);

  }

  async add(parentId: string = undefined) {
    const menus = this.menus$.value;
    const title = await this.translateService.get(this.resolveKey("AddMenu")).toPromise();
    // const item = findItem(menus, id);
    const parent = findItem(menus, parentId);
    this.modalService.create({
      nzTitle: title,
      nzContent: MenuFormComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        items: menus,
        parent: parent
      }
    }).afterClose.pipe(
      filter(_ => _),
      switchMap(() => this.api.getMenuTree()),
      tap(menus => this.menus$.next(menus))
    ).subscribe();
  }


  async edit(id: string) {

    const menus = this.menus$.value;
    const item = findItem(menus, id);
    const parent = findParent(menus, id);
    const title = await this.translateService.get(this.resolveKey("EditMenu")).toPromise();
    this.modalService.create({
      nzTitle: title,
      nzContent: MenuFormComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        model: item,
        items: menus,
        parent: parent
      }
    }).afterClose.pipe(
      filter(_ => _),
      switchMap(() => this.api.getMenuTree()),
      tap(menus => this.menus$.next(menus))
    ).subscribe();


  }

  async delete(id: string) {
    const menus = this.menus$.value;
    const item = findItem(menus, id);
    const collection = findCollection(menus, id);
    collection.splice(collection.indexOf(item), 1);
    await this.api.saveMenuTree(menus).toPromise();
    this.menus$.next(await this.api.getMenuTree().toPromise());
  }

  tableData(item: ExpandMenuItem[]) {
    return item as ExpandMenuItem[];

  }

  export() {
    download(JSON.stringify(this.menus$.value), "menus.json");
  }

  fileChange(file: NzUploadChangeParam) {
    if (file.type === 'start') {
      this.import(file.file);
    }
  }

  import(file) {
  }

  resolveKey(key: string) {
    return `${mmMenuConstants.translationGroup}.${key}`;
  }

  async move(id: string, direction: string) {
    await this.api.move(id, direction).toPromise();
    this.menus$.next(await this.api.getMenuTree().toPromise());

  }

}

function convertToExpandItems(items: MenuItem[], expandSet: any, expandItems: ExpandMenuItem[] = undefined, parent: ExpandMenuItem = undefined) {
  if (!expandItems) {
    expandItems = [];
  }
  let index = 0;
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    var expandItem: ExpandMenuItem = <ExpandMenuItem>{
      ...item
    }
    if (parent) {
      expandItem.level = parent.level + 1;
      expandItem.parant = parent;

    }
    else {
      expandItem.level = 0;
    }
    expandItem.index = index;
    var expand = expandSet[expandItem.id];
    if (expand === undefined) {
      expand = true;
    }
    expandItem.expand = expand;
    expandItem.isFirst = index === 0;
    expandItem.isLast = index == items.length - 1;
    expandItem.hasFolderAbove = index > 0 && items[index - 1].type == "Folder";
    expandItems.push(expandItem);



    if (item.items && item.items.length > 0) {
      expandItem.items = convertToExpandItems(item.items, expandSet, expandItems, expandItem);
    }

  }
  // var newItems: ExpandMenuItem[] = [];
  // for (const item of items) {
  //   var expandItem: ExpandMenuItem = <ExpandMenuItem>{
  //     ...item
  //   }
  //   if (parent) {
  //     expandItem.level = parent.level + 1;
  //     expandItem.parant = parent;

  //   }
  //   else {
  //     expandItem.level = 0;
  //   }
  //   expandItem.index = index++;
  //   expandItem.expand = expandSet.has(item.id);
  //   expandItems.push(expandItem);


  //   if (item.items && item.items.length > 0) {
  //     expandItem.items = convertToExpandItems(item.items, expandSet, expandItems, expandItem);
  //   }
  // }
  return expandItems;
}

function moveUp(items: MenuItem[], id: string) {
  const item = findItem(items, id);
  const collection = findCollection(items, id);
  var index = collection.indexOf(item);
  const temp = collection[index - 1];
  collection[index] = item;
  collection[index - 1] = temp;

}

function moveDown(items: MenuItem[], id: string) {
  const item = findItem(items, id);
  const collection = findCollection(items, id);
  var index = collection.indexOf(item);
  const temp = collection[index + 1];
  collection[index] = item;
  collection[index + 1] = temp;
}

function findCollection(items: MenuItem[], id: string): MenuItem[] {
  for (const item of items) {
    if (item.id == id) return items;
    if (item.items && item.items.length > 0) {
      const childCollection = findCollection(item.items, id);
      if (childCollection && childCollection.length > 0) return childCollection;;
    }
  }
}
function findItem(items: MenuItem[], id: string) {
  for (const item of items) {
    if (item.id == id) return item;
    if (item.items && item.items.length > 0) {
      const childItem = findItem(item.items, id);
      if (childItem) return childItem;
    }
  }

}

function findParent(items: MenuItem[], id: string, parant: MenuItem = undefined): MenuItem {
  for (const item of items) {
    if (item.id == id) return parant;
    if (item.items && item.items.length > 0) {
      const childItem = findItem(item.items, id);
      if (childItem) return childItem;
    }
  }

}
function convertToTreeNodes(items: MenuItem[]) {
  let nodes: NzTreeNode[] = [];
  for (const item of items) {
    let node: NzTreeNode = <NzTreeNode>{
      title: item.localizedName,
      icon: item.icon,
      key: item.id
    }
    if (item.items && item.items.length > 0) {
      node.children = convertToTreeNodes(item.items);
    }
    else {
      node.isLeaf = item.type == "Link";
    }
    nodes.push(node);
  }
  return nodes;

}

export interface ExpandMenuItem extends MenuItem {
  level: number;

  parant: ExpandMenuItem;
  items: ExpandMenuItem[];
  expand: boolean;
  index: number;
  isFirst: boolean;
  isLast: boolean;
  hasFolderAbove: boolean
}
